import { AppLink as Link } from "./AppLink";

export function Breadcrumbs({ items }: { items: { name: string; href: string }[] }) {
  return (
    <nav aria-label="Miga de pan" className="container py-5 text-sm text-slate-600">
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((item, index) => (
          <li key={item.href} className="flex items-center gap-2">
            {index > 0 ? <span aria-hidden="true">/</span> : null}
            {index === items.length - 1 ? <span aria-current="page">{item.name}</span> : <Link className="font-bold text-steel hover:text-cyan" href={item.href}>{item.name}</Link>}
          </li>
        ))}
      </ol>
    </nav>
  );
}
